// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RT2 Projects experience */

.rt-projects {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.rt-projects,
.rt-projects * {
  text-shadow: none;
}

/* Text / labels sit on the card surface — never invent boxes */
.rt-proj-card__name,
.rt-proj-card__desc,
.rt-proj-card__metric-label,
.rt-proj-card__metric-value,
.rt-proj-card__meta,
.rt-proj-card__meta span,
.rt-proj-card__titles,
.rt-proj-table__name,
.rt-proj-table__desc {
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;
  filter: none;
}

.rt-proj-card__metric {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

.rt-projects__toolbar .rt-filter-bar,
.rt-projects__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.rt-projects__toolbar .rt-filter-bar > .rt-projects__search {
  flex: 1 1 220px;
  max-width: 360px;
}

.rt-projects__toolbar .rt-filter-bar > .rt-select,
.rt-projects__toolbar .rt-filter-bar > .rt-select--filter {
  flex: 0 0 auto;
  width: auto;
  min-width: 132px;
  max-width: 180px;
}

.rt-projects__toolbar .rt-filter-bar > .rt-projects__view-toggle,
.rt-projects__toolbar .rt-filter-bar > .rt-btn {
  flex: 0 0 auto;
}

.rt-projects__empty-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.rt-projects__search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 200px;
  max-width: 360px;
  padding: 0 12px;
  height: 38px;
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 10px;
  background: var(--rt-surface, var(--surface));
  color: var(--rt-text-muted, var(--text-muted));
}

.rt-projects__search input {
  flex: 1 1;
  min-width: 0;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  font-family: inherit;
  font-size: 0.875rem;
  color: var(--rt-text, var(--text-primary));
  padding: 0 !important;
}

.rt-projects__select {
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 10px;
  background: var(--rt-surface, var(--surface));
  color: var(--rt-text, var(--text-primary));
  font-family: inherit;
  font-size: 0.8125rem;
}

.rt-projects__view-toggle {
  display: inline-flex;
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 10px;
  overflow: hidden;
  background: var(--rt-surface, var(--surface));
}

.rt-projects__view-toggle button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: var(--rt-text-muted, var(--text-muted));
  cursor: pointer;
}

.rt-projects__view-toggle button.is-active {
  background: color-mix(in srgb, var(--rt-primary, #2563eb) 12%, transparent);
  color: var(--rt-primary, #2563eb);
}

.rt-proj-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 14px;
}

.rt-proj-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: var(--rt-surface, var(--surface));
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 14px;
  transition: border-color 140ms ease, box-shadow 140ms ease;
  min-width: 0;
}

.rt-proj-card:hover {
  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 35%, var(--rt-border, var(--border)));
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.rt-proj-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.rt-proj-card__identity {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.rt-proj-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--rt-primary, #2563eb) 12%, transparent);
  color: var(--rt-primary, #2563eb);
  flex-shrink: 0;
}

.rt-proj-card__titles {
  min-width: 0;
}

.rt-proj-card__name {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0 0 6px;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--rt-text, var(--text-primary));
  cursor: pointer;
  text-align: left;
}

.rt-proj-card:hover .rt-proj-card__name {
  color: var(--rt-primary, #2563eb);
}

.rt-proj-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.rt-proj-card__desc {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--rt-text-muted, var(--text-secondary));
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.rt-proj-card__metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding-top: 4px;
  border-top: 1px solid var(--rt-border-subtle, var(--border));
}

.rt-proj-card__metric {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rt-proj-card__metric-label {
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-text-muted, var(--text-muted));
}

.rt-proj-card__metric-value {
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--rt-text, var(--text-primary));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-proj-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 11px;
  color: var(--rt-text-muted, var(--text-muted));
}

.rt-proj-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding-top: 4px;
}

.rt-proj-health {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--rt-text-muted, var(--text-muted));
  white-space: nowrap;
}

.rt-proj-health__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.rt-proj-health--success {
  color: var(--success, #16a34a);
}
.rt-proj-health--warning {
  color: var(--warning, #d97706);
}
.rt-proj-health--danger {
  color: var(--danger, #dc2626);
}
.rt-proj-health--neutral {
  color: var(--rt-text-muted, #64748b);
}

.rt-proj-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 14px;
  background: var(--rt-surface, var(--surface));
}

.rt-proj-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.rt-proj-table th,
.rt-proj-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid var(--rt-border-subtle, var(--border));
  vertical-align: middle;
}

.rt-proj-table th {
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-text-muted, var(--text-muted));
  background: color-mix(in srgb, var(--rt-text, #0f172a) 3%, transparent);
}

.rt-proj-table tbody tr:last-child td {
  border-bottom: none;
}

.rt-proj-table tbody tr:hover {
  background: color-mix(in srgb, var(--rt-primary, #2563eb) 5%, transparent);
}

.rt-proj-table__name {
  border: none;
  background: transparent;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: 650;
  color: var(--rt-text, var(--text-primary));
  cursor: pointer;
  text-align: left;
}

.rt-proj-table__name:hover {
  color: var(--rt-primary, #2563eb);
}

.rt-proj-table__desc {
  margin-top: 2px;
  font-size: 12px;
  color: var(--rt-text-muted, var(--text-muted));
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-proj-table__actions {
  text-align: right;
  white-space: nowrap;
}

.rt-proj-table__actions .rt-row-actions {
  justify-content: flex-end;
}

@media (max-width: 720px) {
  .rt-proj-card__metrics {
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-projects.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;;;;;;;;;EASE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iDAAiD;EACjD,mBAAmB;EACnB,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,mBAAmB;EACnB,6CAA6C;EAC7C,0CAA0C;EAC1C,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,2EAA2E;EAC3E,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6CAA6C;EAC7C,iDAAiD;EACjD,mBAAmB;EACnB,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,iGAAiG;EACjG,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2EAA2E;EAC3E,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,kDAAkD;EAClD,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,+DAA+D;EAC/D,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* RT2 Projects experience */\n\n.rt-projects {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.rt-projects,\n.rt-projects * {\n  text-shadow: none;\n}\n\n/* Text / labels sit on the card surface — never invent boxes */\n.rt-proj-card__name,\n.rt-proj-card__desc,\n.rt-proj-card__metric-label,\n.rt-proj-card__metric-value,\n.rt-proj-card__meta,\n.rt-proj-card__meta span,\n.rt-proj-card__titles,\n.rt-proj-table__name,\n.rt-proj-table__desc {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  filter: none;\n}\n\n.rt-proj-card__metric {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n.rt-projects__toolbar .rt-filter-bar,\n.rt-projects__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n}\n\n.rt-projects__toolbar .rt-filter-bar > .rt-projects__search {\n  flex: 1 1 220px;\n  max-width: 360px;\n}\n\n.rt-projects__toolbar .rt-filter-bar > .rt-select,\n.rt-projects__toolbar .rt-filter-bar > .rt-select--filter {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 132px;\n  max-width: 180px;\n}\n\n.rt-projects__toolbar .rt-filter-bar > .rt-projects__view-toggle,\n.rt-projects__toolbar .rt-filter-bar > .rt-btn {\n  flex: 0 0 auto;\n}\n\n.rt-projects__empty-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n\n.rt-projects__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 200px;\n  max-width: 360px;\n  padding: 0 12px;\n  height: 38px;\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 10px;\n  background: var(--rt-surface, var(--surface));\n  color: var(--rt-text-muted, var(--text-muted));\n}\n\n.rt-projects__search input {\n  flex: 1;\n  min-width: 0;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-family: inherit;\n  font-size: 0.875rem;\n  color: var(--rt-text, var(--text-primary));\n  padding: 0 !important;\n}\n\n.rt-projects__select {\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 10px;\n  background: var(--rt-surface, var(--surface));\n  color: var(--rt-text, var(--text-primary));\n  font-family: inherit;\n  font-size: 0.8125rem;\n}\n\n.rt-projects__view-toggle {\n  display: inline-flex;\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--rt-surface, var(--surface));\n}\n\n.rt-projects__view-toggle button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: var(--rt-text-muted, var(--text-muted));\n  cursor: pointer;\n}\n\n.rt-projects__view-toggle button.is-active {\n  background: color-mix(in srgb, var(--rt-primary, #2563eb) 12%, transparent);\n  color: var(--rt-primary, #2563eb);\n}\n\n.rt-proj-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 14px;\n}\n\n.rt-proj-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: var(--rt-surface, var(--surface));\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 14px;\n  transition: border-color 140ms ease, box-shadow 140ms ease;\n  min-width: 0;\n}\n\n.rt-proj-card:hover {\n  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 35%, var(--rt-border, var(--border)));\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.rt-proj-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.rt-proj-card__identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.rt-proj-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--rt-primary, #2563eb) 12%, transparent);\n  color: var(--rt-primary, #2563eb);\n  flex-shrink: 0;\n}\n\n.rt-proj-card__titles {\n  min-width: 0;\n}\n\n.rt-proj-card__name {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0 0 6px;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--rt-text, var(--text-primary));\n  cursor: pointer;\n  text-align: left;\n}\n\n.rt-proj-card:hover .rt-proj-card__name {\n  color: var(--rt-primary, #2563eb);\n}\n\n.rt-proj-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.rt-proj-card__desc {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--rt-text-muted, var(--text-secondary));\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.rt-proj-card__metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  padding-top: 4px;\n  border-top: 1px solid var(--rt-border-subtle, var(--border));\n}\n\n.rt-proj-card__metric {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rt-proj-card__metric-label {\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted, var(--text-muted));\n}\n\n.rt-proj-card__metric-value {\n  font-size: 0.9rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--rt-text, var(--text-primary));\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-proj-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  font-size: 11px;\n  color: var(--rt-text-muted, var(--text-muted));\n}\n\n.rt-proj-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 4px;\n}\n\n.rt-proj-health {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--rt-text-muted, var(--text-muted));\n  white-space: nowrap;\n}\n\n.rt-proj-health__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.rt-proj-health--success {\n  color: var(--success, #16a34a);\n}\n.rt-proj-health--warning {\n  color: var(--warning, #d97706);\n}\n.rt-proj-health--danger {\n  color: var(--danger, #dc2626);\n}\n.rt-proj-health--neutral {\n  color: var(--rt-text-muted, #64748b);\n}\n\n.rt-proj-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 14px;\n  background: var(--rt-surface, var(--surface));\n}\n\n.rt-proj-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.rt-proj-table th,\n.rt-proj-table td {\n  padding: 12px 14px;\n  text-align: left;\n  border-bottom: 1px solid var(--rt-border-subtle, var(--border));\n  vertical-align: middle;\n}\n\n.rt-proj-table th {\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted, var(--text-muted));\n  background: color-mix(in srgb, var(--rt-text, #0f172a) 3%, transparent);\n}\n\n.rt-proj-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.rt-proj-table tbody tr:hover {\n  background: color-mix(in srgb, var(--rt-primary, #2563eb) 5%, transparent);\n}\n\n.rt-proj-table__name {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: 650;\n  color: var(--rt-text, var(--text-primary));\n  cursor: pointer;\n  text-align: left;\n}\n\n.rt-proj-table__name:hover {\n  color: var(--rt-primary, #2563eb);\n}\n\n.rt-proj-table__desc {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--rt-text-muted, var(--text-muted));\n  max-width: 320px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-proj-table__actions {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.rt-proj-table__actions .rt-row-actions {\n  justify-content: flex-end;\n}\n\n@media (max-width: 720px) {\n  .rt-proj-card__metrics {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
